import {keyGrey, keyGreyDark, keyOffWhite, keyOrange} from "../../../vars";

let guiItem;

AFRAME.registerComponent('gui-label', {
  schema: {
    value: {type: 'string', default: ''},
      width: {type: 'number', default: 1},
      height: {type: 'number', default: 1},
    align: {type: 'string', default: 'center'},
    anchor: {type: 'string', default: 'center'},
    fontSize: {type: 'number', default: 0.2},
    lineHeight: {type: 'number', default: 0.2},
    letterSpacing: {type: 'number', default: 0},
    fontFamily: {type: 'string', default: ''},
    fontColor: {type: 'string', default: keyOrange},
    backgroundColor: {type: 'string', default: keyOffWhite},
    opacity: { type: 'number', default: 1.0 },
    textDepth: { type: 'number', default: 0.01 },
  },
  init: function() {
    const data = this.data;
      const el = this.el;
    guiItem = el.getAttribute("gui-item");


    //el.setAttribute('geometry', `primitive: plane; height: ${guiItem.height}; width: ${guiItem.width};`);
    //el.setAttribute('material', `shader: flat; side:front; color:${data.backgroundColor}; transparent: true; opacity: ${data.opacity}; alphaTest: 0.5;`);
    
    //fallback for old font-sizing
    if(data.fontSize > 20) { // 150/750
      var newSize = data.fontSize/750;
      data.fontSize = newSize;        
    }

    this.setText(data.value);

    ////WAI ARIA Support

    // if(data.labelFor){
    //   // el.setAttribute('role', 'button');
    // }


    },
    update: function (oldData) {
        var data = this.data;
        var el = this.el;
// @ts-ignore
        if(this.textEntity){
            // @ts-ignore
            console.log("has textEntity: "+this.textEntity);
// @ts-ignore
            var oldEntity = this.textEntity;
            oldEntity.parentNode.removeChild(oldEntity);

            this.setText(this.data.value);

        }else{
            console.log("no textEntity!");
        }
    },
    setText: function (newText) {
        var textEntity = document.createElement("a-entity");
        // @ts-ignore
        this.textEntity = textEntity;
        // @ts-ignore
        const maxWidth = this.data.width/1.05
        textEntity.setAttribute('troika-text', `value: ${newText}; 
                                                align: ${this.data.align}; 
                                                anchor: ${this.data.anchor}; 
                                                baseline:center;
                                                letterSpacing:0;
                                                lineHeight: ${this.data.lineHeight};
                                                color:${this.data.fontColor};
                                                font:${this.data.fontFamily};
                                                fontSize:${this.data.fontSize};
                                                depthOffset:1;
                                                maxWidth:${maxWidth};
                                                `);
        textEntity.setAttribute('position', `0 0 ${this.data.textDepth}`);
//        textEntity.setAttribute('troika-text-material', `shader: flat;`);
        this.el.appendChild(textEntity);
    }
});

AFRAME.registerPrimitive( 'a-gui-label', {
  defaultComponents: {
    'gui-label': { }
  },
  mappings: {
    'width': 'gui-label.width',
    'height': 'gui-label.height',
    'margin': 'gui-label.margin',
    'align': 'gui-label.align',
    'anchor': 'gui-label.anchor',
    'value': 'gui-label.value',
    'font-size': 'gui-label.fontSize',
    'line-height': 'gui-label.lineHeight',
    'letter-spacing': 'gui-label.letterSpacing',
    'font-color': 'gui-label.fontColor',
    'font-family': 'gui-label.fontFamily',
    'background-color': 'gui-label.backgroundColor',
    'opacity': 'gui-label.opacity',
    'text-depth': 'gui-label.textDepth'
  }
 });
export {}
